<div class="card-footer">
    <ng-content></ng-content>
</div>